var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.027 19.9185C10.1962 19.9185 10.3692 19.8516 10.499 19.7218C10.7586 19.4622 10.7586 19.0375 10.499 18.7779L1.61448 9.89336L10.3692 1.1386C10.6288 0.879029 10.6288 0.45427 10.3692 0.194695C10.1097 -0.0648803 9.6849 -0.0648803 9.42532 0.194695L0.194681 9.4214C-0.0648937 9.68098 -0.0648937 10.1057 0.194681 10.3653L9.55118 19.7218C9.6849 19.8555 9.854 19.9185 10.027 19.9185Z",
    fill: "#F0E1CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColarrow);
export default __webpack_public_path__ + "static/media/colarrow.cb0ccf4c413db32bed0604d6c586b8c0.svg";
export { ForwardRef as ReactComponent };